/* batida-loc-pill-state.js — 2026-05-29 (FIX Batida V.5.3.5)
   Recovers the location-pill "registered" (navy) state. The styling lives in
   batida-loc-pill-v60f.css (.batida-loc-btn.is-batida-loc-set → navy #1F4054).
   That CSS needs the .is-batida-loc-set class applied, which used to be done by
   __batidaApplyLocState() in snippets/zip-cookies.liquid — but the deployed
   zip-cookies.liquid reverted to an older version that lacks it. This small
   self-contained script restores exactly that behaviour without redeploying the
   whole snippet: navy when a real location is chosen, default (unset) when none
   is set or the modal was dismissed ("wybierz"). */
(function () {
  function getCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function apply() {
    var zip = getCookie('zip_cookie');
    var city = getCookie('city_cookie');
    // Unset when nothing chosen, or when the modal was dismissed (city = "wybierz").
    var label = city || zip;
    var unset = (zip === '' && city === '') || label === 'wybierz';
    var btns = document.querySelectorAll('.batida-loc-btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('is-batida-loc-unset', unset);
      btns[i].classList.toggle('is-batida-loc-set', !unset);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  // pill can hydrate slightly after DOMContentLoaded — re-apply a few times
  [200, 600, 1500].forEach(function (ms) { setTimeout(apply, ms); });
})();
